import {
	IntroHeaderFieldsFragment,
	SeoFieldsFragment,
	SeoSingleFieldsFragment,
	WooRequestFieldsFragment
} from 'api/graphql-types';
import { Head } from 'modules/head/head';
import IntroHeader from 'modules/intro-header/intro-header';

export type OpenHeaderProps = WooRequestFieldsFragment & { seo?: SeoSingleFieldsFragment };

const OpenHeader = ({ title, description, slug, seo }: OpenHeaderProps): React.JSX.Element => {
	const pageSeo: SeoFieldsFragment = {
		__typename: 'ComponentModulesSeo',
		title: title,
		description: description,
		ogType: 'website',
		ogTitle: title,
		ogDescription: description
	};

	const header: IntroHeaderFieldsFragment = {
		__typename: 'ComponentModulesIntroHeader',
		title: title || '',
		excerpt: ' ',
		backgroundColor: 'grey'
	};

	return (
		<>
			<Head seoModule={pageSeo} seoParent={seo} />
			<IntroHeader module={header} slug={slug} showBreadCrumbs />
		</>
	);
};

export default OpenHeader;
